import React from "react";
import { CgClose } from "react-icons/cg";
import StatusBatchUpdater from "./StatusBatchUpdater";

const index = ({ showPopup, modalRef, closePopup, handleSubmit, loading, currentCPDStatus }) => {
    return (
        <div className="Confirm_popup">
            <div className={`modal custom-popup-overlay ${showPopup ? "show" : ""}`}>
                <div
                    className="modal-content custom-popup-add"
                    ref={modalRef}>
                    <div className="d-flex flex-row-reverse">
                        <div>
                            <span
                                className="cursor-pointer"
                                onClick={closePopup}>
                                <CgClose
                                    style={{
                                        color: "#D1D5DB",
                                        height: "30px",
                                        width: "30px",
                                    }}
                                />
                            </span>
                        </div>
                    </div>

                    <div>
                        <StatusBatchUpdater
                            closePopup={closePopup}
                            handleSubmit={handleSubmit}
                            loading={loading}
                            currentCPDStatus={currentCPDStatus}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default index;
